export const chartingStateKey = 'CHARTING' as const;
